export const AllServices = [
  "AI_DETECTION",
  "SOURCE_DETECTION",
  "WRITING_ANALYSIS",
  "QUILLBOT_ANALYSIS",
  "AI_DETECTION_HIGHLIGHTER",
  "PLAGIARISM",
  "HUMANIZER",
  "AI_WRITER",
  "REWRITE",
  "SUMMARIZE",
  "EXPAND",
  "SHORTEN",
  "ADD_CONTENT",
  "PII_TEXT_DETECT",
  "VEXON",
] as const;
export type AllServices = (typeof AllServices)[number];
